import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import http from '../config/http-service';
import type { MasterProductFamily } from './types';
import { masterProductFamiliesEndpoint } from './use-get-master-product-families-api';

type TData = MasterProductFamily;
type TError = AxiosError;
type TQueryKey = [string, number | undefined];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

// GET ums/v1/cms/master-product-families/:id
export function useGetMasterProductFamilyApi(id?: number, options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();
  // Destructure to compose caller enabled with built-in guards (never replace)
  const { enabled: callerEnabled, ...restOptions } = options ?? {};

  const queryFn = async () => {
    const { data } = await http.get(`${masterProductFamiliesEndpoint}/${id}`);
    // The API wraps the resource in an envelope: { data: {...} } — unwrap so
    // callers (merge modal, family detail) get the family directly.
    return data?.data ?? data;
  };

  return useQueryWrapper([masterProductFamiliesEndpoint, id], queryFn, {
    enabled: (callerEnabled ?? true) && isLoggedIn && id != null,
    ...restOptions,
  });
}
